import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const AGBPage = () => {
  return (
    <div className="pt-20 pb-16 min-h-screen bg-white">
      <SEO
        title="Allgemeine Geschäftsbedingungen (AGB)"
        description="Allgemeine Geschäftsbedingungen der LAIzyones. Geltungsbereich, Leistungen, Zahlungsbedingungen und mehr."
        path="/agb"
        breadcrumbs={[
          { name: 'Startseite', url: '/' },
          { name: 'AGB' },
        ]}
      />
      <div className="container-custom max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-emerald-600 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="heading-xl text-3xl md:text-4xl text-gray-900 mb-10">Allgemeine Geschäftsbedingungen (AGB)</h1>

        <div className="prose prose-gray max-w-none
          [&_h3]:font-['Space_Grotesk'] [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:text-gray-900 [&_h3]:mt-8 [&_h3]:mb-3
          [&_p]:text-gray-600 [&_p]:leading-relaxed [&_p]:mb-3
          [&_ul]:text-gray-600 [&_ul]:pl-5 [&_ul]:mb-3 [&_ul]:space-y-1
          [&_li]:text-gray-600
          [&_hr]:my-8 [&_hr]:border-gray-200
          [&_a]:text-emerald-600 [&_a]:no-underline hover:[&_a]:underline
        ">
          <h3>1. Geltungsbereich</h3>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen
            Laizyones, Inhaber David Ehrle, Ferdinand-Lentjes-Straße 32, 39167 Wellen,
            Deutschland, und seinen Kunden.
          </p>
          <p>
            Die Leistungen von Laizyones richten sich ausschließlich an Unternehmen im Sinne
            des § 14 BGB, juristische Personen des öffentlichen Rechts oder öffentlich-rechtliche
            Sondervermögen.
          </p>
          <p>
            Abweichende oder entgegenstehende Bedingungen des Kunden werden nur dann
            Vertragsbestandteil, wenn ihrer Geltung ausdrücklich schriftlich zugestimmt wurde.
          </p>
          <p>
            Mit der Beauftragung von Laizyones, dem Erwerb eines Produkts oder der Nutzung
            einer von Laizyones bereitgestellten Dienstleistung oder Anwendung erklärt sich
            der Kunde ausdrücklich mit diesen Allgemeinen Geschäftsbedingungen sowie der{' '}
            <Link to="/datenschutz">Datenschutzerklärung</Link> von Laizyones einverstanden.
            Die AGB und Datenschutzbestimmungen gelten als anerkannt, sobald der Kunde eine
            Bestellung aufgibt, einen Vertrag abschließt oder eine Anwendung von Laizyones nutzt.
          </p>

          <hr />

          <h3>2. Leistungen von Laizyones</h3>
          <p>
            Laizyones bietet Dienstleistungen im Bereich der Digitalisierung und
            Prozessoptimierung durch künstliche Intelligenz an.
          </p>
          <p>Hierzu gehören insbesondere:</p>
          <ul>
            <li>Analyse von Geschäftsprozessen</li>
            <li>Beratung zu Automatisierungs- und KI-Lösungen</li>
            <li>Entwicklung und Integration von KI-Tools</li>
            <li>Optimierung von Unternehmensabläufen</li>
            <li>Implementierung digitaler Systeme</li>
          </ul>
          <p>Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Angebot oder Vertrag.</p>

          <hr />

          <h3>3. Vertragsschluss</h3>
          <p>Ein Vertrag zwischen Laizyones und dem Kunden kommt zustande durch:</p>
          <ul>
            <li>schriftliche Annahme eines Angebots</li>
            <li>elektronische Bestätigung (z. B. per E-Mail)</li>
            <li>oder durch Beginn der Leistungserbringung nach Zustimmung des Kunden.</li>
          </ul>

          <hr />

          <h3>4. Mitwirkungspflichten des Kunden</h3>
          <p>
            Der Kunde verpflichtet sich, alle für die Durchführung der vereinbarten Leistungen
            erforderlichen Informationen, Daten und Zugänge rechtzeitig bereitzustellen.
          </p>
          <p>
            Kommt der Kunde seinen Mitwirkungspflichten nicht nach, kann sich die
            Leistungserbringung entsprechend verzögern. Daraus entstehende Mehrkosten können
            dem Kunden in Rechnung gestellt werden.
          </p>

          <hr />

          <h3>5. Vergütung und Zahlungsbedingungen</h3>
          <p>Die Vergütung richtet sich nach dem individuell vereinbarten Angebot.</p>
          <p>Sofern nicht anders vereinbart:</p>
          <ul>
            <li>sind Rechnungen innerhalb von 14 Tagen ohne Abzug zu begleichen</li>
            <li>erfolgt die Zahlung per Überweisung</li>
          </ul>
          <p>Laizyones ist berechtigt, angemessene Vorauszahlungen zu verlangen.</p>

          <hr />

          <h3>6. Haftung</h3>
          <p>
            Laizyones haftet nur für Schäden, die auf vorsätzlichem oder grob fahrlässigem
            Verhalten beruhen.
          </p>
          <p>
            Für mittelbare Schäden, entgangenen Gewinn oder wirtschaftliche Folgeschäden wird
            keine Haftung übernommen.
          </p>
          <p>
            Die Nutzung von KI-Systemen kann zu automatisierten Ergebnissen führen, deren
            Richtigkeit nicht in jedem Fall garantiert werden kann. Entscheidungen, die auf Basis
            solcher Ergebnisse getroffen werden, liegen in der Verantwortung des Kunden.
          </p>
          <p>
            Laizyones übernimmt grundsätzlich keine Haftung für fehlerhafte, unvollständige
            oder ungenaue Ergebnisse, die im Zusammenhang mit der Nutzung individuell
            entwickelter oder bereits bestehender KI-Lösungen entstehen. Der Kunde ist
            verpflichtet, alle durch KI generierten Ergebnisse eigenständig zu prüfen, bevor
            diese als Grundlage für geschäftliche Entscheidungen herangezogen werden.
          </p>

          <hr />

          <h3>6a. Besondere Bestimmungen für LAIzyleads</h3>
          <p>
            LAIzyleads ist eine KI-gestützte Plattform zur B2B-Leadgenerierung. Die folgenden
            Bestimmungen gelten ergänzend für die Nutzung von LAIzyleads:
          </p>
          <ul>
            <li>
              <strong className="text-gray-900">Keine Haftung für extrahierte Leads:</strong> Laizyones übernimmt keine Haftung für Schäden, die durch die Nutzung,
              Kontaktaufnahme oder geschäftliche Beziehungen mit über LAIzyleads gefundenen
              oder vorgeschlagenen Leads entstehen.
            </li>
            <li>
              <strong className="text-gray-900">Keine Gewähr für Richtigkeit:</strong> Da es sich um KI-gestützte Datenextraktion handelt, kann es zu Abweichungen,
              fehlerhaften oder veralteten Ergebnissen kommen. Insbesondere wird keine Gewähr
              für die Richtigkeit, Vollständigkeit oder Aktualität der bereitgestellten
              Kontaktdaten und Unternehmensinformationen übernommen.
            </li>
            <li>
              <strong className="text-gray-900">Prüfpflicht des Kunden:</strong> Der Kunde ist verpflichtet, alle durch LAIzyleads generierten Leads
              und Daten eigenständig auf Korrektheit zu überprüfen, bevor er diese für
              geschäftliche Zwecke verwendet.
            </li>
            <li>
              <strong className="text-gray-900">Kündigung:</strong> Das LAIzyleads-Abonnement ist monatlich kündbar. Die Kündigung kann
              per E-Mail an <a href="mailto:info@laizyones.de">info@laizyones.de</a> oder
              telefonisch unter 0172 1771141 erfolgen. Die Kündigung wird zum Ende des
              laufenden Abrechnungszeitraums wirksam.
            </li>
          </ul>

          <hr />

          <h3>6b. Besondere Bestimmungen für LAIzyblueprint</h3>
          <p>
            LAIzyblueprint ist eine KI-gestützte Anwendung zur Erstellung von
            Leistungsverzeichnissen auf Basis eingelesener und bearbeiteter Grundrisse.
            Die folgenden Bestimmungen gelten ergänzend für die Nutzung von LAIzyblueprint:
          </p>
          <ul>
            <li>
              <strong className="text-gray-900">Keine Haftung für erstellte Leistungsverzeichnisse:</strong> Laizyones übernimmt keine Haftung für Schäden, die durch die Nutzung
              von Leistungsverzeichnissen entstehen, die mit LAIzyblueprint erstellt wurden.
              Die generierten Ergebnisse dienen als Unterstützung und ersetzen keine
              fachkundige Prüfung.
            </li>
            <li>
              <strong className="text-gray-900">KI-bedingte Abweichungen:</strong> Da LAIzyblueprint auf KI-gestützter Datenextraktion aus Grundrissen basiert,
              kann es zu Abweichungen, Ungenauigkeiten oder fehlerhaften Berechnungen kommen.
              Die Ergebnisse sind als Richtwerte zu verstehen.
            </li>
            <li>
              <strong className="text-gray-900">Prüfpflicht des Kunden:</strong> Jeder Nutzer ist verpflichtet, alle durch LAIzyblueprint generierten
              Ergebnisse und Leistungsverzeichnisse eigenständig und vollständig auf Richtigkeit
              zu überprüfen, bevor diese für Ausschreibungen, Kalkulationen oder sonstige
              geschäftliche Zwecke verwendet werden.
            </li>
            <li>
              <strong className="text-gray-900">Kündigung:</strong> Das LAIzyblueprint-Abonnement ist monatlich kündbar. Die Kündigung kann
              per E-Mail an <a href="mailto:info@laizyones.de">info@laizyones.de</a> oder
              telefonisch unter 0172 1771141 erfolgen. Die Kündigung wird zum Ende des
              laufenden Abrechnungszeitraums wirksam.
            </li>
          </ul>

          <hr />

          <h3>7. Vertraulichkeit</h3>
          <p>
            Beide Vertragsparteien verpflichten sich, alle im Rahmen der Zusammenarbeit
            erhaltenen vertraulichen Informationen streng vertraulich zu behandeln und nicht an
            Dritte weiterzugeben.
          </p>
          <p>Diese Verpflichtung bleibt auch nach Beendigung des Vertrags bestehen.</p>

          <hr />

          <h3>8. Nutzungsrechte</h3>
          <p>
            Sofern im Rahmen eines Projekts Softwarelösungen, Automatisierungen, Konzepte oder
            Dokumentationen erstellt werden, erhält der Kunde ein einfaches Nutzungsrecht im
            vereinbarten Umfang.
          </p>
          <p>
            Die Weitergabe oder kommerzielle Nutzung außerhalb des vereinbarten Zwecks bedarf
            der vorherigen Zustimmung von Laizyones.
          </p>

          <hr />

          <h3>9. Datenschutz</h3>
          <p>
            Laizyones verarbeitet personenbezogene Daten ausschließlich im Einklang mit der
            Datenschutz-Grundverordnung (DSGVO) und den geltenden Datenschutzbestimmungen.
          </p>
          <p>
            Weitere Informationen zur Datenverarbeitung sind in der{' '}
            <Link to="/datenschutz">Datenschutzerklärung</Link> auf der Website von Laizyones enthalten.
          </p>

          <hr />

          <h3>10. Schlussbestimmungen</h3>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
          </p>
          <p>
            Gerichtsstand für alle Streitigkeiten aus diesem Vertragsverhältnis ist, soweit
            gesetzlich zulässig, der Sitz des Unternehmens.
          </p>
          <p>
            Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder
            werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AGBPage;
